import {
  ANALYTICS_PRODUCT_NOT_APPLICABLE,
  AnalyticsData,
  AnalyticsService,
  NotAvailable,
  sendCustomDataEventToAnalytics,
  sendCustomEventToAnalytics,
  sendPageViewEventToAnalytics,
} from '@ui-common/analytics'

import { IfpLoansAnalyticsModalName, IfpLoansCustomEventName, IfpLoansPageViewEvent } from './types'

export class IfpLoansAnalyticsService extends AnalyticsService<
  IfpLoansPageViewEvent,
  IfpLoansCustomEventName,
  IfpLoansAnalyticsModalName
> {
  constructor(private readonly data?: AnalyticsData) {
    super()
  }

  getCommonData = (): AnalyticsData => {
    return (
      this.data ?? {
        src: NotAvailable,
        flow: NotAvailable,
        product: ANALYTICS_PRODUCT_NOT_APPLICABLE,
        version: NotAvailable,
        ui_lang: NotAvailable,
      }
    )
  }

  sendPageViewEvent = (view: IfpLoansPageViewEvent): void => {
    sendPageViewEventToAnalytics(view, this.getCommonData())
  }

  sendCustomDataEvent = (data: { [p: string]: string }): void => {
    sendCustomDataEventToAnalytics(data)
  }

  sendCustomEvent = (view: IfpLoansPageViewEvent, name: IfpLoansCustomEventName): void => {
    sendCustomEventToAnalytics(view, name, this.getCommonData())
  }

  sendModalViewEvent = (modal: IfpLoansAnalyticsModalName): void => {
    sendPageViewEventToAnalytics(modal, this.getCommonData())
  }
}
